import React from 'react';
import classNames from 'classnames';
import SortableListItem from '@/components/ui/drag-and-drop/sortable-list-item/SortableListItem';
import {
  Dropdown,
  Icon,
  IconButton,
  useResponsiveValue,
} from '@monash/portal-react';
import ParkType from '../../park-type/ParkType';
import { DROPDOWN_ITEM_CLASSNAME } from '../EditCarparks';
import { CARPARK_BREAKPOINTS, SEARCH_TERM_MAP } from '../../constants';
import c from './edit-carpark-row.module.scss';

export const EditCarparkMobileRow = ({
  selectedCarpark,
  selectedCarparks,
  setSelectedCarparks,
  assembledParkingLocations,
  onOpenBottomSheet,
  isEditing,
}) => {
  const selectedValues = selectedCarparks.map((carpark) => carpark.value);
  const responsiveSize = useResponsiveValue(CARPARK_BREAKPOINTS);

  const enrichedCarpark = assembledParkingLocations.find((location) => {
    return location.id === selectedCarpark.value;
  });

  const carparkName = enrichedCarpark?.name || 'unselected carpark';

  const carparkDropdownItems = assembledParkingLocations
    .map(({ id, name, colour }) => {
      const label = (
        <div className={c.parkTypes}>
          {colour.map((colour) => (
            <ParkType
              key={colour}
              type={colour}
              className={c.parkType}
              hideText={responsiveSize === 'S'}
            />
          ))}
        </div>
      );

      return {
        id,
        text: name,
        value: id,
        label,
        searchString: `${colour} ${SEARCH_TERM_MAP[colour]}`,
      };
    })
    .filter(
      (item) =>
        !selectedValues.includes(item.value) ||
        item.value === selectedCarpark.value
    );

  const updateCarparks = (updatedCarpark) => {
    setSelectedCarparks((carparks) => {
      return carparks.map((carpark) => {
        if (carpark.id === updatedCarpark.id) {
          return updatedCarpark;
        }
        return carpark;
      });
    });
  };

  return (
    <SortableListItem
      id={selectedCarpark.id}
      className={classNames(c.listItem, { [c.shadow]: isEditing })}
      itemLabel={carparkName}
    >
      <Dropdown
        placeholder="Select or search for a carpark location or permit type"
        id="type"
        className={DROPDOWN_ITEM_CLASSNAME}
        onChange={(value) => {
          updateCarparks({ id: selectedCarpark.id, value });
        }}
        value={selectedCarpark.value}
        data={carparkDropdownItems}
        searchable
      />

      {onOpenBottomSheet && (
        <IconButton
          onClick={onOpenBottomSheet}
          variant="text"
          mode="card"
          icon={Icon.DotsHorizontal}
          size={24}
          color="var(--card-text-color)"
          aria-label={`More options for ${carparkName}`}
        />
      )}
    </SortableListItem>
  );
};
